import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import FormattedDateTime from 'rebook/apps/base/components/FormattedDateTime';
import SubscriptionIcon from 'rebook/apps/base/components/icons/SubscriptionIcon';
import PaymentsRibbon from 'rebook/apps/payments/components/PaymentsRibbon';

import stylesInner from './style.scss';


const SubscriptionLabel = ({ type, dateTillString }) => {
  return (
    <Link
      to="/account/subscriptions/"
      className={classNames(
        stylesInner.subscriptionType,
        stylesInner[`subscriptionType${type}`],
        `jest-${type}-subscription-type-informer`)}>
      <div className={classNames(
        stylesInner.header,
        stylesInner[`header${type}`])}>
        {type==='audio' && <PaymentsRibbon size={'small'} />}
        <SubscriptionIcon
          type={type}
          extraClassName={stylesInner.subscriptionIcon} />

        <div className={stylesInner.period}>
          <div className={stylesInner.periodLabel}>
            {type==='standard' ? 'Стандарт' : 'Премиум'}
          </div>
          <div className={stylesInner.periodTime}>
            до <FormattedDateTime timestamp={dateTillString} format="D.MM.YYYY" />
          </div>
        </div>
      </div>
      <div className={stylesInner.availableTypes}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="9"
          className={stylesInner.availableTypesIcon}>
          <path
            fill="none"
            stroke="#383434"
            // eslint-disable-next-line max-len
            d="M1 1l4 1.6L9 1v4.923a1 1 0 0 1-.629.928L5.743 7.903a2 2 0 0 1-1.486 0L1.63 6.85A1 1 0 0 1 1 5.923V1z" />
        </svg>
        <span className={stylesInner.availableTypesLabel}>
          {type==='standard' ? 'Классика и бестселлеры' : 'Все книги'}
        </span>
        {type==='audio' && (
          <div className={stylesInner.availableTypesBooks}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="10"
              className={stylesInner.availableTypesIcon}>
              <path
                fill="#383434"
                fillRule="evenodd"
                // eslint-disable-next-line max-len
                d="M1.513 5.457l.157-.042a1 1 0 0 1 1.26.966v2.335a1 1 0 0 1-1.212.977l-.253-.055A1.857 1.857 0 0 1 0 7.823V7.38C0 6.849.21 6.359.56 6H.5C.5 2.413 2.03.501 5 .501c2.96 0 4.485 1.9 4.485 5.462.322.343.515.804.515 1.3v.495c0 .884-.598 1.656-1.455 1.877l-.204.053a1 1 0 0 1-1.25-.968V6.337a1 1 0 0 1 1.234-.972l.146.035C8.336 2.737 7.203 1.5 5 1.5c-2.22 0-3.357 1.254-3.487 3.956z" />
            </svg>
            <span className={stylesInner.availableTypesLabel}>
              Аудиокниги
            </span>
          </div>
        )}
      </div>
    </Link>
  );
};

SubscriptionLabel.propTypes = {
  type: PropTypes.string.isRequired,
  dateTillString: PropTypes.string.isRequired,
};

export default SubscriptionLabel;
